import classes from "../forms/forms.module.css";
import React from "react";

const SubmitButton = ({text, isAnimating, disabled}) => {

    return (
        <div className={classes.submitSticky}>
            <button
                type='submit'
                className={`${classes.submit}`}
                disabled={isAnimating || disabled}
            >
                {isAnimating ?

                    <svg width="24" height="24" viewBox="0 0 50 50">
                        <circle
                            cx="25"
                            cy="25"
                            r="20"
                            stroke="rgba(255,255,255,0.2)"
                            strokeWidth="4"
                            fill="none"
                        />
                        <circle
                            cx="25"
                            cy="25"
                            r="20"
                            stroke="#fff"
                            strokeWidth="4"
                            fill="none"
                            strokeDasharray="30 94"
                            strokeLinecap="round"
                        >
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                values="0 25 25;180 25 25;0 25 25"
                                dur="1.5s"
                                repeatCount="indefinite"
                                calcMode="spline"
                                keyTimes="0;0.5;1"
                                keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
                            />
                        </circle>
                    </svg>

                    : `${text}`}
            </button>
        </div>
    )
}

export default SubmitButton;